export default __webpack_public_path__ + "static/elizabeth-5db1d690b522aff74d317d8f3c2a5d00.jpeg";